import { render, staticRenderFns } from "./InspectForm.vue?vue&type=template&id=8f9857c0&"
import script from "./InspectForm.vue?vue&type=script&lang=js&"
export * from "./InspectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports